import * as actionTypes from '../constants/actionTypes';
export function orientationChanged(orientation) {
    return {
        type: actionTypes.ORIENTATION_CHANGED,
        orientation: orientation,
    };
}
